import { store } from "@/stores/global.js";
import { getToolToken } from "@/apis/ums/auth";

let toolName;
const DATA_FARM = {
    lookup: {},
    chartdata: {},
};
const DEFAULT_CACHE_TIME = 1; // minute

export function register(inToolname) {
    toolName = inToolname;
}

function buildURL() {
    return `https://${store.env}.quotemedia.com/datatool/`;
}

export async function getData(api, params, type = "GET") {
    let dataURL = `${buildURL()}${api}.json?`;
    dataURL = new URL(dataURL);

    dataURL.searchParams.set("webmaster_id", store.wmid);
    dataURL.searchParams.set("webmasterId", store.wmid);
    dataURL.searchParams.set("qmodTool", toolName);
    dataURL.searchParams.set("pathName", window.location.pathname);
    if (store.sid) dataURL.searchParams.set("sid", store.sid);

    const options = {
        credentials: "include",
        headers: {
            "Accept-Language": "en",
            "Content-Type": "application/json",
            "Datatool-Token": await getToolToken(toolName),
        },
    };

    if (type === "POST") {
        options.method = "POST";
        options.body = JSON.stringify(params);
    } else {
        Object.entries(params).forEach(([key, value]) => {
            if (value != null) {
                dataURL.searchParams.set(key, value);
            }
        });
    }

    let result = await fetch(dataURL.toString(), options);

    result = await result.json();

    return result;
}

export async function get$enhanced$quotes(symbols, extraHours = false) {
    let returnData = [];
    const lastTime = Date.now();

    let filteredSymbols = symbols.split(",").filter(element => {
        if (DATA_FARM[element] && DATA_FARM[element].lastTime > lastTime) {
            returnData[element] = DATA_FARM[element];
        } else {
            return element;
        }
    });

    if (filteredSymbols.length) {
        let dataURL = `${buildURL()}getEnhancedQuotes.json`;
        dataURL = new URL(dataURL);
        dataURL.search = new URLSearchParams({
            timezone: "true",
            currencyInd: "true",
            token: await getToolToken(toolName),
            symbols: filteredSymbols.join(","),
            afterhours: extraHours,
            premarket: extraHours,
            marketstatus: extraHours,
        });

        if (store.sid) dataURL.searchParams.set("sid", store.sid);

        let result = await fetch(dataURL.toString(), {
            credentials: "include",
            headers: {
                "Accept-Language": "en",
            },
        });

        result = await result.json();

        result.results.quote.forEach(element => {
            element.lastTime = lastTime + DEFAULT_CACHE_TIME * 60 * 1000;
            DATA_FARM[element.symbolstring] = element;
            returnData[element.symbolstring] = element;
        });
    }

    return returnData;
}

export async function get$symbol$lookup(query) {
    if (DATA_FARM["lookup"][query]) {
        return DATA_FARM["lookup"][query];
    }

    let dataURL = `${buildURL()}lookup.json?`;
    dataURL = new URL(dataURL);
    dataURL.search = new URLSearchParams({
        token: await getToolToken(toolName),
        q: query,
    });

    let result = await fetch(dataURL.toString(), {
        credentials: "include",
        headers: {
            "Accept-Language": "en",
        },
    });

    result = await result.json();

    DATA_FARM["lookup"][query] = result;
    return result;
}

export async function get$enhanced$chartdata(symbol, chartParams, force = false) {
    const cacheKey = `${chartParams.start}|${chartParams.adjType}|${chartParams.interval}|${chartParams.freq}`;
    let returnData = [];
    const lastTime = Date.now();

    DATA_FARM["chartdata"][symbol] ? "" : (DATA_FARM["chartdata"][symbol] = {});

    let filteredSymbols = symbol.split(",").filter(element => {
        if (
            !force && // Skip cache if force is true
            DATA_FARM["chartdata"][element][cacheKey] &&
            DATA_FARM["chartdata"][element][cacheKey].lastTime > lastTime
        ) {
            returnData = DATA_FARM["chartdata"][element][cacheKey];
        } else {
            return element;
        }
    });

    if (filteredSymbols.length) {
        let dataURL = `${buildURL()}getEnhancedChartData.json?`;
        dataURL = new URL(dataURL);
        dataURL.search = new URLSearchParams(chartParams);

        dataURL.searchParams.set("token", await getToolToken(toolName));
        dataURL.searchParams.set("symbol", filteredSymbols.join(","));

        let result = await fetch(dataURL.toString(), {
            credentials: "include",
            headers: {
                "Accept-Language": "en",
            },
        });

        result = await result.json();

        result.results.lastTime = lastTime + DEFAULT_CACHE_TIME * 60 * 1000;
        DATA_FARM["chartdata"][symbol][cacheKey] = result.results;

        returnData = result.results;

        // result.results.forEach(element => {
        //   element.lastTime = lastTime + (DEFAULT_CACHE_TIME * 60 * 1000)
        //   DATA_FARM['chartdata'][element.symbolstring] = element;
        //   returnData[element.symbolstring] = element;
        // });
    }

    return returnData;
}

export async function get$indicators$by$symbol(symbolString, eventType) {
    let dataURL = `${buildURL()}getIndicatorsBySymbol.json?`;
    dataURL = new URL(dataURL);

    let p = {
        earnings: false,
        splits: false,
        dividends: false,
    };

    p[eventType] = true;

    if (eventType !== "all") {
        dataURL.search = new URLSearchParams(p);
    }

    dataURL.searchParams.set("token", await getToolToken(toolName));
    dataURL.searchParams.set("symbol", symbolString);

    let result = await fetch(dataURL.toString(), {
        credentials: "include",
        headers: {
            "Accept-Language": "en",
        },
    });

    result = await result.json();

    return result;
}

export async function getEarningsSurprisesBySymbol(symbol) {
    return getData("getEarningsSurprisesBySymbol", { symbol });
}

export async function getSplitsBySymbol(symbol) {
    return getData("getSplitsBySymbol", { symbol });
}

export async function getDividendsBySymbol(symbol) {
    return getData("getDividendsBySymbol", { symbol });
}

export async function getEarningsEventsBySymbol(symbol) {
    return getData("getEarningsEventsBySymbol", { symbol });
}

export async function getBrokerRatingsBySymbol(symbol) {
    return getData("getBrokerRatingsBySymbol", { symbol });
}

export async function getPremiumFundData(symbol) {
    return getData("getPremiumFundData", { symbol });
}

export async function getSnapQuotes(symbol) {
    return getData("getSnapQuotes", { symbols: symbol });
}

export async function getGlobalIndustrySectorPeers(sector) {
    let dataURL = `${buildURL()}getGlobalIndustrySectorPeers.json?`;
    dataURL = new URL(dataURL);

    let p = {
        sector: sector,
        limit: 500,
        country: "US",
    };

    dataURL.search = new URLSearchParams(p);

    dataURL.searchParams.set("token", await getToolToken(toolName));

    let result = await fetch(dataURL.toString(), {
        credentials: "include",
        headers: {
            "Accept-Language": "en",
        },
    });

    result = await result.json();

    return result;
}

export async function getMSCIResearchESG(symbol) {
    let dataURL = `https://${store.env}.quotemedia.com/v3/msci/research/esg`;

    dataURL = new URL(dataURL);

    let p = {
        symbol,
    };

    dataURL.search = new URLSearchParams(p);

    dataURL.searchParams.append("webmaster_id", store.wmid);
    if (store.sid) dataURL.searchParams.append("sid", store.sid);
    dataURL.searchParams.append("module", "datatool");
    dataURL.searchParams.set("token", await getToolToken(toolName));

    let result = await fetch(dataURL.toString(), {
        headers: {
            "Accept-Language": "en",
        },
    });

    result = await result.json();

    return result;
}

export async function getAllGlobalIndustrySectorPeers() {
    const allSectors = Promise.all([
        getGlobalIndustrySectorPeers(101),
        getGlobalIndustrySectorPeers(102),
        getGlobalIndustrySectorPeers(103),
        getGlobalIndustrySectorPeers(104),
        getGlobalIndustrySectorPeers(105),
        getGlobalIndustrySectorPeers(106),
        getGlobalIndustrySectorPeers(107),
        getGlobalIndustrySectorPeers(108),
        getGlobalIndustrySectorPeers(109),
        getGlobalIndustrySectorPeers(110),
        getGlobalIndustrySectorPeers(111),
    ]);

    return allSectors;
}

export async function getCompanyFilings(params) {
    return getData("getCompanyFilings", params);
}

export async function get$quotes(params, token = null) {
    const url = new URL(`https://${store.env}.quotemedia.com/v3/quotes`);

    url.searchParams.append("token", token === null ? await getToolToken(toolName) : token);
    url.searchParams.append("webmaster_id", store.wmid);
    if (store.sid) url.searchParams.append("sid", store.sid);
    url.searchParams.append("module", "datatool");

    for (const key in params) {
        url.searchParams.append(key, params[key]);
    }

    const response = await fetch(url.toString(), {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
        },
        credentials: "include",
    });

    if (!response) {
        return { error: "No response" };
    }

    return response;
}

export async function get$peers$by$symbol(symbol, limit = 10, naics, securityType) {
    if (naics)
        return getData("getIndustrySectorPeers", {
            peerSymbol: symbol,
            limit,
            securityType: securityType,
        });
    return getData("getGlobalIndustrySectorPeers", {
        peerSymbol: symbol,
        limit,
        securityType: securityType,
    });
}

export async function get$movers(params) {
    return getData("getMarketStats", params);
}

export async function get$chart$data(params) {
    const url = new URL(`https://${store.env}.quotemedia.com/v3/chart/enhanced`);

    url.searchParams.append("token", await getToolToken(toolName));
    url.searchParams.append("webmaster_id", store.wmid);
    if (store.sid) url.searchParams.append("sid", store.sid);
    url.searchParams.append("module", "datatool");

    for (const key in params) {
        url.searchParams.append(key, params[key]);
    }

    const response = await fetch(url.toString(), {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
        },
        credentials: "include",
    });

    if (!response) {
        return { error: "No response" };
    }

    return response;
}

export async function get$company$profile(symbol) {
    const url = new URL(`https://${store.env}.quotemedia.com/v3/companies/profile`);

    url.searchParams.append("token", await getToolToken(toolName));
    url.searchParams.append("webmaster_id", store.wmid);
    if (store.sid) url.searchParams.append("sid", store.sid);
    url.searchParams.append("module", "datatool");
    url.searchParams.append("symbols", symbol);

    const response = await fetch(url.toString(), {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
        },
        credentials: "include",
    });

    if (!response) {
        return { error: "No response" };
    }

    return response;
}
